import { useTranslation } from 'react-i18next'

const Kitchen3 = (props) => {
  const { t } = useTranslation()

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="kitchen3-title"
      {...props}
    >
      <title id="kitchen3-title">{t('antagonists:parentsdivorcing:components:background')}</title>
      <defs>
        <clipPath id="kitchen3-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="kitchen3-b">
          <path
            style={{
              fill: '#007858',
            }}
            d="M816.74 938.34 815.95 571l-1192.78.5-.01-3.92-280.46-1.08-1.47 371.25 1475.51.59z"
          />
        </clipPath>
        <clipPath id="kitchen3-c">
          <path
            style={{
              fill: '#dfe6e7',
            }}
            d="m535.54 574.24-.38 385.59 289.64 3.15-6.45-389.66-282.81.92z"
          />
        </clipPath>
        <clipPath id="kitchen3-d">
          <path
            style={{
              fill: '#f5f1e7',
            }}
            d="M1351.54 93.59V538.4l511.49.29 1.32-444.81-512.81-.29z"
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#kitchen3-a)',
        }}
      >
        <path
          style={{
            fill: '#fffdf6',
          }}
          d="M-202.76-170.64H2122.6V960.91H-202.76z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#fae5d9',
          }}
          d="M-295.81 804.61h2433.77v676.64H-295.81z"
        />
        <path
          style={{
            fill: '#a5ccdb',
          }}
          d="m816.15 570.77-1646.98 20.57V-51.4H817l-.85 622.17z"
        />
        <path
          style={{
            fill: '#007858',
          }}
          d="M816.74 938.34 815.95 571l-1192.78.5-.01-3.92-280.46-1.08-1.47 371.25 1475.51.59z"
        />
        <g
          style={{
            clipPath: 'url(#kitchen3-b)',
          }}
        >
          <path
            style={{
              fill: '#dfe6e7',
            }}
            d="m535.54 574.24-.38 385.59 289.64 3.15-6.45-389.66-282.81.92z"
          />
          <g
            style={{
              clipPath: 'url(#kitchen3-c)',
            }}
          >
            <path
              d="M518.06 641.05h327.5l-4.28 234.3-318.95 2.57s-5.13-237.72-4.28-236.86Z"
              style={{
                fill: '#becccf',
              }}
            />
            <path
              d="M519.9 873.18h327.5l-4.28 234.3-318.95 2.57s-5.13-237.72-4.28-236.86Z"
              style={{
                fill: '#007858',
              }}
            />
            <path
              style={{
                fill: '#2e425b',
              }}
              d="m565.94 655.58.55 9.53 225.2.73v-9.4l-225.75-.86zm13.68 31.64.86 115.44 192.39 2.56v-118H579.62z"
            />
          </g>
          <path
            d="M630.9 618.22c6.54-.57 9.27-5.53 8.78-9.84-.57-5.01-3.87-8.58-9.85-8.41-5.65.16-9.73 4.98-8.44 10.96 1.07 4.94 4.64 7.71 9.5 7.29Zm94.13 0c6.54-.57 9.27-5.53 8.78-9.84-.57-5.01-3.87-8.58-9.85-8.41-5.65.16-9.73 4.98-8.44 10.96 1.07 4.94 4.64 7.71 9.5 7.29Z"
            style={{
              fill: '#8cabbc',
            }}
          />
        </g>
        <path
          style={{
            fill: '#007858',
          }}
          d="m-1015.65-54.73.79 444.9 1543.1 2.72-.06-444.57-1543.83-3.05z"
        />
        <path
          style={{
            fill: '#0a9791',
          }}
          d="m508.08 368.01-.48-342.72-174.04-.94v341.77l174.52 1.89zM146.18 25.8l2.45 338.29 178.07.99-2.15-342.27-178.37 2.99zm103.48 573.22-.45 72.61 273.87 3.77-.45-74.52-272.97-1.86zm-.44 83.51 271.64 3.12.89 66.94-271.63-1.23-.9-68.83zm1.11 77.3 272.08 1.23.44 64.41-273.41-1.24.89-64.4zm.22 73.02.45 45.04 273.37 1.53v-45.21l-273.82-1.36z"
        />
        <path
          d="M303.79 330.71c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm50.37 0c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Z"
          style={{
            fill: '#1a4431',
          }}
        />
        <path
          style={{
            fill: '#0a9791',
          }}
          d="m127.03 366.74-.48-342.72-174.04-.94v341.77l174.52 1.89z"
        />
        <path
          d="M392.03 624.83c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm.49 83.67c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm-.16 76.57c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm2.07 71.89c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Z"
          style={{
            fill: '#1a4431',
          }}
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m628.16-69.16 1.81 344.96-101.67 94.41-.12 22.8 289.21.62v-23.07l-111.16-98.39-1.82-339.52-76.25-1.81z"
        />
        <path
          style={{
            fill: '#0a9791',
          }}
          d="m229.64 881.45 3.96-282.14-174.04-.94-4.44 281.19 174.52 1.89zm-357.91-281.67-7.24 276.4 178.08.99 7.53-280.39-178.37 3z"
        />
        <path
          d="M82.38 634.56c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Zm-57.35-4.22c5.99-.52 8.49-5.07 8.04-9-.52-4.59-3.54-7.85-9.02-7.7-5.17.14-8.9 4.56-7.72 10.03.98 4.52 4.25 7.06 8.7 6.67Z"
          style={{
            fill: '#1a4431',
          }}
        />
        <path
          style={{
            fill: '#1c3628',
          }}
          d="m105.5 422.39 206.91.73v6.33l-207.4-.49.49-6.57z"
        />
        <path
          d="M147.21 474.47h.12l-.09-49.83c0-1.7-1.31-3.08-2.93-3.08s-2.93 1.38-2.93 3.08l-.09 49.83h.12c-4.12 8.39-11.96 25.52-11.96 34.59 0 11.84 6.25 20.43 14.86 20.43s14.86-8.59 14.86-20.43c0-9.07-7.84-26.2-11.96-34.59Zm-11.19 34.59c0-8.69 4.67-25.49 7.2-33.94-.94 8.54-2.63 25.24-2.63 33.94 0 1.75.07 14.9 2.23 19.12-3.96-1.57-6.79-9.25-6.79-19.12Zm5.56 0c0-8.92 1.8-26.34 2.71-34.59h.04c.91 8.25 2.71 25.67 2.71 34.59 0 13.56-1.81 19.43-2.73 19.43s-2.73-5.7-2.73-19.43Zm4.23 19.12c2.16-4.23 2.23-17.37 2.23-19.12 0-8.7-1.7-25.4-2.63-33.94 2.52 8.45 7.19 25.25 7.19 33.94 0 9.87-2.83 17.56-6.79 19.12Zm-3.34-103.55c0-.54.2-1.05.56-1.43.34-.36.8-.56 1.28-.56 1.02 0 1.84.89 1.84 1.99v3.9h-3.68v-3.9Zm-12.02 84.42c0-8.57 7.47-25.1 11.61-33.61-2.58 8.65-7.05 24.89-7.05 33.61s2.12 15.66 5.39 18.72c-5.95-2.19-9.96-9.39-9.96-18.72Zm17.76 18.72c3.27-3.06 5.39-10.01 5.39-18.72s-4.47-24.96-7.05-33.62c4.14 8.51 11.61 25.05 11.61 33.62 0 9.33-4.01 16.53-9.96 18.72Z"
          style={{
            fill: '#e6f1e2',
          }}
        />
        <path
          d="M236.31 517.91c-1.22 8.86-5.04 14.96-7.02 17.4-1.31 1.61-6.6 2.44-8.59 0-1.98-2.44-5.8-8.55-7.02-17.4-1.22-8.86 8.55-13.74 9.31-16.95.76-3.21-2.6-65.04-2.9-72.98-.23-6.03 1.72-7.09 4.95-7.17s5.09 1.77 4.86 7.17c-.34 7.94-3.66 69.77-2.9 72.98.76 3.21 10.53 8.09 9.31 16.95Zm-11.18-89.02c1.97-.17 2.79-1.66 2.64-2.96-.17-1.51-1.16-2.58-2.96-2.53-1.7.05-2.93 1.5-2.54 3.3.32 1.49 1.4 2.32 2.86 2.19Zm-16.05 74.61c-1.15 7.54-4.74 12.74-6.6 14.82-1.23 1.37-6.21 2.08-8.08 0s-5.46-7.28-6.6-14.82c-1.15-7.54 8.04-11.7 8.76-14.43.72-2.73-2.44-55.39-2.73-62.15-.22-5.13 1.62-6.04 4.65-6.1s4.79 1.51 4.57 6.1c-.32 6.76-3.45 59.42-2.73 62.15.72 2.73 9.91 6.89 8.76 14.43Zm-10.51-75.81c1.85-.15 2.62-1.42 2.49-2.52-.16-1.28-1.09-2.2-2.79-2.16-1.6.04-2.75 1.28-2.39 2.81.3 1.27 1.31 1.98 2.69 1.87ZM293.21 456.16l-1.18-49.2s-5.92 1.13-7.05 9.73-1.67 40.55-1.67 40.55l9.9-1.07Z"
          style={{
            fill: '#fcf4e1',
          }}
        />
        <path
          d="M287.95 514.15c6.46-.6 6.03-6.25 5.89-19.36-.13-11.86-.02-34.75 0-39.01 0-.37-.32-.65-.68-.61l-10.46 1.26-.18 1.88c-.05.49.21.96.65 1.2 1.14.61 3.15 2.29 2.66 6.38-.63 5.22-1.87 17.31-2.05 22.66-.13 3.85.89 13.25.1 14.97-.65 1.42-1.84 2.01-2.59 2.24a.76.76 0 0 0-.51.9c.47 2.11 2.22 7.96 7.19 7.49Z"
          style={{
            fill: '#2e425b',
          }}
        />
        <path
          d="M289.63 477.67c-1.21.11-1.71 1.02-1.62 1.81.11.92.71 1.58 1.82 1.55 1.04-.03 1.79-.92 1.56-2.02-.2-.91-.86-1.42-1.75-1.34Zm0-12.93c-1.21.11-1.71 1.02-1.62 1.81.11.92.71 1.58 1.82 1.55 1.04-.03 1.79-.92 1.56-2.02-.2-.91-.86-1.42-1.75-1.34Z"
          style={{
            fill: '#fcf4e1',
          }}
        />
        <path
          style={{
            fill: '#f5f1e7',
          }}
          d="M1351.54 93.59V538.4l511.49.29 1.32-444.81-512.81-.29z"
        />
        <g
          style={{
            clipPath: 'url(#kitchen3-d)',
          }}
        >
          <path
            style={{
              fill: '#e9edf2',
            }}
            d="m1597.33 72.84 12.26 503.82 4.02 1.11-12.26-506.04-4.02 1.11z"
          />
        </g>
        <path
          style={{
            fill: '#c7e6f5',
          }}
          d="m1584.05 481.34-1.57-366.51h-212.35l3.98 365.15 209.94 1.36z"
        />
        <path
          style={{
            fill: '#e3e8ef',
          }}
          d="m1892.69 541.64.48-22.65-576.2-4-.67 25.47 576.39 1.18z"
        />
        <path
          style={{
            fill: '#c4e5f5',
          }}
          d="m1627.88 481.34-5.16-370.49h220.1l-3.61 369.95-211.33.54z"
        />
        <path
          d="m1583.67 305.65 4.96 45.2h8.68l2.95-45.46s-1.56-7-8.3-7c-7.28 0-8.3 7.26-8.3 7.26Zm25.35 3.96 17.88 41.8 8.31-2.52-10.39-44.35s-3.52-6.25-9.97-4.29c-6.96 2.12-5.83 9.36-5.83 9.36Z"
          style={{
            fill: '#95b6c4',
          }}
        />
        <path
          style={{
            fill: '#ffea97',
          }}
          d="m1332.68-68.71-3.38 219.67 550.79-5.54 1.6-229.17-549.01 15.04z"
        />
        <path
          style={{
            fill: '#272a3e',
          }}
          d="m570.04 461.3-.86-13.23 16.17.13-.72 11.07-14.59 2.03zm19.59 2.27v13.54h25.01l2.59 35.76 3.74 1.04v-50.34h-31.34z"
        />
        <path
          style={{
            fill: '#a0a5b5',
          }}
          d="M549.05 556.71h57.02l-2.67-36.66h-51.67l-2.68 36.66zm42.74-101.03-29.24-.46-10.61 61.92h51.24l-11.39-61.46z"
        />
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m551.94 517.14-.21 2.91h51.67l-.22-2.91h-51.24z"
        />
        <path
          style={{
            fill: '#d7c498',
          }}
          d="m-572.25 572.45 1396.21 6.92-.38-23.41-1395.86-12.68.03 29.17z"
        />
      </g>
    </svg>
  )}

export default Kitchen3
